document.addEventListener("DOMContentLoaded", () => {
  const heroBtn = document.querySelector('.hero__btn');
  const formPopup = document.getElementById('formPopup');
  const thanksPopup = document.getElementById('thanksPopup');
  const rateForm = document.getElementById('rateForm');
  const getRatesBtn = document.getElementById('getRatesBtn');

  if (heroBtn && formPopup) {
    heroBtn.addEventListener('click', () => {
      formPopup.classList.add('active');
    });
  }

  [formPopup, thanksPopup].forEach(popup => {
    if (popup) {
      popup.addEventListener('click', (e) => {
        if (e.target === popup) {
          popup.classList.remove('active');
          if (rateForm) rateForm.reset();
        }
      });
    }
  });

  // if (rateForm && formPopup && thanksPopup) {
  //   rateForm.addEventListener('submit', function (e) {
  //     e.preventDefault();

  //     const formData = new FormData(rateForm);

  //     fetch("send.php", {
  //       method: "POST",
  //       body: formData
  //     })
  //       .then(response => response.text())
  //       .then(result => {
  //         console.log("Server response:", result);

  //         formPopup.classList.remove('active');
  //         thanksPopup.classList.add('active');
  //         rateForm.reset();
  //       })
  //       .catch(error => {
  //         console.error("Error:", error);
  //       });
  //   });
  // }

  // if (getRatesBtn && thanksPopup) {
  //   getRatesBtn.addEventListener('click', () => {
  //     window.location.href = "./pdf/2026-OE-full.pdf";
  //     thanksPopup.classList.remove('active');
  //   });
  // }
});
